import { ClientOnly, createFileRoute } from "@tanstack/react-router";

import { MarketingCTA } from "@/web/routes/-marketing/MarketingCTA";
import { MarketingFooter } from "@/web/routes/-marketing/MarketingFooter";
import { MarketingNavbar } from "@/web/routes/-marketing/MarketingNavbar";
import { AboutConversation } from "@/web/routes/-marketing/about/AboutConversation";
import { AboutHeader } from "@/web/routes/-marketing/about/AboutHeader";
import { AboutStory } from "@/web/routes/-marketing/about/AboutStory";
import { AboutTeam } from "@/web/routes/-marketing/about/AboutTeam";
import { appUrl } from "@/web/lib/siteUrls";

export const Route = createFileRoute("/about-us")({
  ssr: true,
  head: () => ({
    meta: [
      { title: "About Us — WITH.CO" },
      {
        name: "description",
        content: "Recapturing the American dream — our story, our team, and the people behind it.",
      },
      { property: "og:title", content: "About Us — WITH.CO" },
      {
        property: "og:description",
        content: "Recapturing the American dream — our story, our team, and the people behind it.",
      },
      { property: "og:url", content: appUrl("/about-us") },
      { property: "og:type", content: "website" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex w-full flex-col overflow-x-clip">
      {/* Navbar depends on Clerk + scroll position — client-only to avoid SSR hangs. */}
      <ClientOnly>
        <MarketingNavbar solid />
      </ClientOnly>

      <main className="flex w-full flex-col">
        <AboutHeader />
        <AboutStory />
        <AboutConversation />
        <AboutTeam />
        <MarketingCTA />
      </main>

      <MarketingFooter />
    </div>
  );
}
